import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import { ChildMapRenderer } from '../components';
import { isObjectEmptyValues } from '../../../../utils/index.js';
import invoiceConfig from '../../../../const/invoice.json';
import { getSelectRectKey } from '../utils';

/**
 * Invoice 渲染器 - 票据识别结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const InvoiceRenderer = ({ params, config, detail, selectRect, onSelect }) => {
  return (
    <>
      {params[config.firstField]?.map((v, vindex) => {
        const OtherTexts = v.SingleInvoiceInfos[v.SubType];
        const invoiceDetailConfig = invoiceConfig[v.SubType] || invoiceConfig.default;
        const selectRectVal = getSelectRectKey({
          data: v,
          key: detail?.rectConfig?.RectKey,
          valStr: v.SubType
        });

        return (
          <div
            key={`invoice-${vindex}`}
            onClick={() => {
              onSelect && onSelect(v.SubType, selectRectVal);
            }}
            className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} invoiceContent`}
          >
            <Form.Item active label="票据类型" className="unv-form__item-group">
              {config.invoiceTypeMap[v.Type]}
            </Form.Item>
            <Form.Item active label="旋转角度" className="unv-form__item-group">
              {v.Angle}
            </Form.Item>
            <Form.Item active label="位置信息" className="unv-form__item-group">
              {JSON.stringify(v.Polygon)}
            </Form.Item>

            {OtherTexts && (
              <>
                {Object.keys(OtherTexts)?.map((k, kindex) => {
                  if (OtherTexts[k] !== '' && !(OtherTexts[k] instanceof Object)) {
                    return (
                      <Fragment key={`other-${kindex}`}>
                        <ChildMapRenderer
                          keyName={k}
                          value={OtherTexts[k]}
                          dep={0}
                          config={invoiceDetailConfig}
                        />
                      </Fragment>
                    );
                  } else if (OtherTexts[k] instanceof Object) {
                    if (isObjectEmptyValues(OtherTexts[k])) {
                      return <Fragment key={`empty-${kindex}`} />;
                    }
                    return (
                      <Fragment key={`obj-${kindex}`}>
                        <Form.Item
                          active
                          label={`${invoiceDetailConfig[k]?._Label || '其他字段'}`}
                          className="unv-form__item-group"
                        >
                          {OtherTexts[k]?.map((o, oi) => {
                            if (o.OtherInvoiceItemList) {
                              return (
                                <Fragment key={`other-list-${oi}`}>
                                  {o.OtherInvoiceItemList?.map((other, otherIdx) => (
                                    <p key={`other-item-${otherIdx}`} className="mb-10">
                                      <span><b>{other.Name}: </b></span>
                                      <span>{other.Value}</span>
                                    </p>
                                  ))}
                                </Fragment>
                              );
                            } else if (o.Name && o.Value) {
                              return (
                                <p key={`p-${oi}`} className="mb-10">
                                  <span><b>{o.Name}: </b></span>
                                  <span>{o.Value}</span>
                                </p>
                              );
                            } else if (!isObjectEmptyValues(o)) {
                              return (
                                <Fragment key={`obj-inner-${oi}`}>
                                  {Object.keys(o)?.map((ckey, cindex) => {
                                    if (o[ckey] || o[ckey] === 0) {
                                      return (
                                        <p key={`ckey-${cindex}`} className="mb-10">
                                          <span>
                                            <b>{invoiceDetailConfig[k]?.[ckey]?._Label || invoiceDetailConfig[k]?.[ckey] || ckey}: </b>
                                          </span>
                                          <span>{o[ckey]}</span>
                                        </p>
                                      );
                                    }
                                    return null;
                                  })}
                                </Fragment>
                              );
                            }
                            return null;
                          })}
                        </Form.Item>
                      </Fragment>
                    );
                  }
                  return null;
                })}
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

export default InvoiceRenderer;
